
export class Country {
    intCountryID: number = 0;
    strName: string = '';
    strCode: string = '';
    createdAt: string = '';
    updatedAt: string = '';
}
